module.exports = __webpack_public_path__ + "static/media/Integrity_Logo.11467cd1.svg";